import type { AlertMessage } from './alert-message'

export type Alert = {
  title: ?string,
  dismissed: boolean,
  messages: AlertMessage[]
}

const buildAlert = (): Alert => {
  return {
    title: null,
    dismissed: true,
    messages: []
  }
}

export {
  buildAlert
}



// WEBPACK FOOTER //
// ./src/types/alert.js